module.exports = __webpack_public_path__ + "img/intro-long.1e8c9e06.png";